import React from "react";

import logo from "@src/assets/images/sa-logo.svg?url";

import styles from "./Header.module.scss";
import { LanguageSwitch } from "@src/components/ui/LanguageSwitch";

interface HeaderProps {
  onLogoClick: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onLogoClick }) => {
  return (
    <div className={styles.root}>
      <div className={styles.logoWrapper}>
        <img src={logo} alt="Spatial Audio" onClick={onLogoClick} />
      </div>
      <div className={styles.languageSwitchWrapper}>
        <LanguageSwitch />
      </div>
    </div>
  );
};
